<template>
  <div id="app">
    <Header />
    <Page no-image>
      <div class="pb-8 px-content pt-8">
        <h2 class="subheadline">Mit Stil und Substanz sicher greifen</h2>
        <div class="flex justify-center">
          <h1 class="headline">Innentreppengeländer</h1>
        </div>

        <p class="mt-4 font-semibold text-gray-800">
          Ein Geländer ist mehr als ein notwendiges Sicherheitselement. Es prägt den Charakter einer Treppe, gibt Struktur und sorgt für das Gefühl von Sicherheit – jedes Mal, wenn man sich daran festhält. Deshalb legen wir bei unseren Innentreppengeländern Wert auf Design, Materialqualität und präzise Ausführung.
        </p>

        <p class="mt-4 text-gray-700">
          Ob mit senkrechten oder mitlaufenden Stacheten, wir fertigen Geländer, die sich harmonisch ins Raumkonzept einfügen oder bewusst Akzente setzen. Wer es offener und moderner mag, entscheidet sich für eine elegante Glasfüllung, die Licht durchlässt und Räume großzügig wirken lässt.
        </p>

        <p class="mt-4 text-gray-700">
          Unsere Geländer erhalten je nach Wunsch eine robuste Grundierung, eine farbige Pulverbeschichtung oder werden aus hochwertigem Edelstahl gefertigt – für ein langlebiges Ergebnis, das nicht nur funktional ist, sondern auch optisch überzeugt. So entsteht aus jedem Geländer ein stilvolles Bauteil, das Sicherheit und Ästhetik auf den Punkt bringt.
        </p>

        <PhotoGallery :images="images" class="mt-8 mb-4" />
      </div>

      <ProduktKontaktformular product="Innentreppengeländer" pixelEvent="FormInnentreppengelaenderSent" />
      <CallToAction />
    </Page>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import CallToAction from "../../components/CallToAction.vue";
import Page from "../../components/Page.vue";
import ProduktKontaktformular from "../../components/ProduktKontaktformular.vue";
import PhotoGallery from "../../components/PhotoGallery.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    ProduktKontaktformular,
    PhotoGallery,
  },
  data() {
    return {
      images: [
        { src: "img/produkte/innentreppengelaender/1.jpg", alt: "Innentreppengeländer 1" },
        { src: "img/produkte/innentreppengelaender/2.jpg", alt: "Innentreppengeländer 2" },
        { src: "img/produkte/innentreppengelaender/3.jpg", alt: "Innentreppengeländer 3" },
        { src: "img/produkte/innentreppengelaender/4.jpg", alt: "Innentreppengeländer 4" },
        { src: "img/produkte/innentreppengelaender/5.jpg", alt: "Innentreppengeländer 5" },
        { src: "img/produkte/innentreppengelaender/6.jpg", alt: "Innentreppengeländer 6" },
        { src: "img/produkte/innentreppengelaender/7.jpg", alt: "Innentreppengeländer 7" },
      ],
    };
  },
};
</script>

<style src="../../assets/css/comfortaa.css"></style>
<style src="../../assets/css/styles.css"></style>
